module.exports = __webpack_public_path__ + "static/media/Q_2_16.ceb0dc95.png";